/* global
  OLD_RIDE_FLOW_AGENCIES,
*/

import _ from 'underscore';

import Coordinate from 'common/types/Coordinate';
import {naturalSort, omitNull} from 'common/utils';

export const products = {
  ONDEMAND: 'ondemand',
  ARCHITECT: 'architect',
};

export const roles = {
  ADMIN: 'admin',
  AGENT: 'agent',
  DISPATCHER: 'dispatcher',
  DRIVER: 'driver',
  EDITOR: 'editor',
  SUPER: 'super',
  USER: 'user',
};

export const permissions = {
  UPDATE_ADDRESS: 'update_address',
  UPDATE_AGENCY: 'update_agency',
  VIEW_AGENCY: 'view_agency',
  VIEW_DEVICE: 'view_device',
  VIEW_FEED: 'view_feed',
  UPDATE_FEED: 'update_feed',
  PUBLISH_FEED: 'publish_feed',
  VIEW_SHARED_PUBLISHED_FEEDS: 'view_shared_published_feeds',
  VIEW_ALL_PUBLISHED_FEEDS: 'view_all_published_feeds',
  VIEW_INSTANT_REPLAYER: 'view_instant_replayer',
  UPDATE_REGION: 'update_region',
  VIEW_REGION: 'view_region',
  VIEW_REPORT: 'view_report',
  CREATE_RIDE: 'create_ride',
  UPDATE_RIDE: 'update_ride',
  VIEW_RIDE: 'view_ride',
  VIEW_ROUTE: 'view_route',
  VIEW_SCHEDULE: 'view_schedule',
  UPDATE_SERVICE: 'update_service',
  VIEW_SERVICE: 'view_service',
  CHANGE_VEHICLE_STATUS: 'change_vehicle_status',
  UPDATE_VEHICLE_ELIGIBILITY: 'update_vehicle_eligibility',
  UPDATE_VEHICLE_POSITION: 'update_vehicle_position',
  UPDATE_VEHICLE: 'update_vehicle',
  VIEW_VEHICLE: 'view_vehicle',
  REALTIME_PUBLISH_FEED: 'realtime_publish_feed',
  VIEW_USER: 'view_user',
  UPDATE_WHITELISTED_RIDER: 'update_whitelisted_rider',
};

const rolePermissions = {
  architect: {
    admin: [permissions.VIEW_FEED, permissions.UPDATE_FEED, permissions.PUBLISH_FEED],
    editor: [permissions.VIEW_FEED, permissions.UPDATE_FEED],
    user: [permissions.VIEW_FEED],
  },
  ondemand: {
    admin: [
      permissions.UPDATE_ADDRESS,
      permissions.UPDATE_AGENCY,
      permissions.VIEW_AGENCY,
      permissions.VIEW_DEVICE,
      permissions.VIEW_REGION,
      permissions.UPDATE_REGION,
      permissions.VIEW_REPORT,
      permissions.CREATE_RIDE,
      permissions.VIEW_RIDE,
      permissions.UPDATE_RIDE,
      permissions.VIEW_SCHEDULE,
      permissions.UPDATE_SERVICE,
      permissions.VIEW_SERVICE,
      permissions.VIEW_USER,
      permissions.UPDATE_VEHICLE,
      permissions.VIEW_VEHICLE,
      permissions.UPDATE_WHITELISTED_RIDER,
      permissions.UPDATE_VEHICLE_ELIGIBILITY,
      permissions.UPDATE_VEHICLE_POSITION,
    ],
    agent: [permissions.CREATE_RIDE, permissions.VIEW_RIDE],
    dispatcher: [
      permissions.VIEW_AGENCY,
      permissions.VIEW_DEVICE,
      permissions.VIEW_REGION,
      permissions.VIEW_REPORT,
      permissions.CREATE_RIDE,
      permissions.VIEW_RIDE,
      permissions.UPDATE_RIDE,
      permissions.VIEW_SCHEDULE,
      permissions.VIEW_SERVICE,
      permissions.VIEW_USER,
      permissions.UPDATE_VEHICLE,
      permissions.VIEW_VEHICLE,
      permissions.UPDATE_WHITELISTED_RIDER,
      permissions.UPDATE_VEHICLE_ELIGIBILITY,
      permissions.UPDATE_VEHICLE_POSITION,
    ],
    driver: [
      permissions.CREATE_RIDE,
      permissions.VIEW_RIDE,
      permissions.UPDATE_RIDE,
      permissions.VIEW_VEHICLE,
      permissions.UPDATE_VEHICLE_ELIGIBILITY,
      permissions.UPDATE_VEHICLE_POSITION,
    ],
  },
};

export default class Agency {
  /* eslint-disable camelcase */
  constructor({agency_id, name, short_name, long_name, position, roles, timezone}) {
    // FIXME: At time of writing, these are only used by the ondemand app.
    // It is possible that further investigation could remove these customizations.
    this.agencyId = agency_id;
    this.position = position ? new Coordinate(position.latitude, position.longitude) : null;

    this.name = name || '';
    this.short_name = short_name || '';
    this.long_name = long_name || '';
    this.roles = roles || [];
    this.timezone = timezone;
    this.old_ride_flow_enabled = _.contains(OLD_RIDE_FLOW_AGENCIES, this.name);
  }
  /* eslint-enable camelcase */

  isAdmin(product) {
    return _.some(
      _.map(
        this.roles,
        (role) =>
          role.product === product && (role.role === roles.ADMIN || role.role === roles.SUPER),
      ),
    );
  }

  clone() {
    return new Agency(this.serialize());
  }

  compare(other) {
    return naturalSort.compare(this.long_name, other.long_name);
  }

  getPermissions(product) {
    const productRoles = this.roles
      .filter((role) => role.product === product)
      .map((role) => role.role);

    // if they are a superuser, assume all permissions
    if (productRoles.includes(roles.SUPER)) {
      return Object.values(permissions);
    }
    return productRoles
      .map((role) => {
        return rolePermissions[product] ? rolePermissions[product][role] : [];
      })
      .flat();
  }

  serialize() {
    return omitNull({
      name: this.name,
      short_name: this.short_name,
      long_name: this.long_name,
      position: this.position ? {latitude: this.position.lat, longitude: this.position.lng} : null,
      roles: _.map(this.roles, (role) => ({
        product: role.product,
        role: role.role,
      })),
      timezone: this.timezone,
    });
  }

  isDifferent(other) {
    return !_.isEqual(this.serialize(), other.serialize());
  }
}



// WEBPACK FOOTER //
// ./src/common/types/Agency.js